import Vue from 'vue'
import moment from 'moment'
import { trans } from 'utils/helpers/translation'

Vue.filter('pmlCalcAge', function (value) {
    return trans('xx_years_old', [moment().diff(moment(value), 'years')])
})



// WEBPACK FOOTER //
// ./src/utils/filters/calc-age.js